var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_vm._v(_vm._s(_vm.content.length)+" "+_vm._s(_vm.$i18n.t('subform_field_record_amount')))])}
var staticRenderFns = []

export { render, staticRenderFns }